import { createFileRoute } from "@tanstack/react-router";

import OfflineFallbackPage from "@/components/pages/OfflineFallbackPage";

export const Route = createFileRoute("/~offline")({
  component: OfflineFallbackPage,
});
